export const sortCodePattern = "^[0-9]{2}-?[0-9]{2}-?[0-9]{2}";
export const validSortCode = (sortCode?: string): boolean => {
  return sortCode !== undefined && new RegExp(sortCodePattern).test(sortCode);
};

export const accountNumberPattern = "^[0-9]{8}";
export const validAccountNumber = (accountNumber?: string): boolean => {
  return accountNumber !== undefined && new RegExp(accountNumberPattern).test(accountNumber);
};
